enum NetworkStatus {
    loading,
    refetch,
    loadMore,
    ready,
    pending,
}

export default NetworkStatus;
